export default "__VITE_ASSET__CPlE1XlK__"